import { number, object, string } from "yup";

export const sugerenciaEmpaqueValidationSchema = object({
  alias: string(),
  cultivo_id: number().moreThan(0).required(),
  tipo_etiqueta_id: number().moreThan(0).required(),
  peso_envase_id: number().moreThan(0).required(),
  tipo_caja_id: number().moreThan(0).required(),
  etiqueta_id: number().moreThan(0).required(),
  palet_id: number(),
  bultos: number().moreThan(0).required(),
});
